import { Link } from 'react-router-dom';
import { apartments } from '../../../mocks/apartments';

const ApartmentsSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-nature-green text-sm font-semibold uppercase tracking-wider mb-3">
            Os Nossos Alojamentos
          </p>
          <h2 className="text-4xl md:text-5xl font-light text-navy-blue mb-4">
            Escolha o Seu <span className="font-serif italic">Apartamento</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Quatro apartamentos únicos, cada um com o seu charme especial e vistas deslumbrantes
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <Link
            to={`/apartamento-${apartments[0].id}`}
            className="group relative h-[480px] rounded-3xl overflow-hidden cursor-pointer"
            data-product-shop
          >
            <div className="absolute inset-0 w-full h-full">
              <img
                src={apartments[0].image}
                alt={apartments[0].name}
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            </div>
            
            <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full">
              <span className="text-navy-blue font-semibold text-sm">{apartments[0].type}</span>
            </div>

            <div className="absolute bottom-0 left-0 right-0 p-6 bg-white/95 backdrop-blur-md">
              <h3 className="text-2xl font-bold text-navy-blue mb-3">{apartments[0].name}</h3>
              <div className="flex items-center gap-4 text-gray-600 text-sm mb-4">
                <span className="flex items-center gap-1">
                  <i className="ri-user-line"></i> {apartments[0].capacity} pessoas
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-hotel-bed-line"></i> {apartments[0].beds} cama
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-water-flash-line"></i> {apartments[0].view}
                </span>
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <span className="text-nature-green font-bold text-2xl">€{apartments[0].price}</span>
                  <span className="text-gray-500 text-sm">/noite</span>
                </div>
                <button className="px-6 py-2.5 border-2 border-sea-blue text-sea-blue rounded-full font-semibold hover:bg-sea-blue hover:text-white transition-all whitespace-nowrap group-hover:bg-sea-blue group-hover:text-white">
                  Ver Detalhes
                </button>
              </div>
            </div>
          </Link>

          <Link
            to={`/apartamento-${apartments[1].id}`}
            className="group relative h-[480px] rounded-3xl overflow-hidden cursor-pointer"
            data-product-shop
          >
            <div className="absolute inset-0 w-full h-full">
              <img
                src={apartments[1].image}
                alt={apartments[1].name}
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            </div>
            
            <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full">
              <span className="text-navy-blue font-semibold text-sm">{apartments[1].type}</span>
            </div>

            <div className="absolute bottom-0 left-0 right-0 p-6 bg-white/95 backdrop-blur-md">
              <h3 className="text-2xl font-bold text-navy-blue mb-3">{apartments[1].name}</h3>
              <div className="flex items-center gap-4 text-gray-600 text-sm mb-4">
                <span className="flex items-center gap-1">
                  <i className="ri-user-line"></i> {apartments[1].capacity} pessoas
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-hotel-bed-line"></i> {apartments[1].beds} cama
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-mountain-line"></i> {apartments[1].view}
                </span>
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <span className="text-nature-green font-bold text-2xl">€{apartments[1].price}</span>
                  <span className="text-gray-500 text-sm">/noite</span>
                </div>
                <button className="px-6 py-2.5 border-2 border-sea-blue text-sea-blue rounded-full font-semibold hover:bg-sea-blue hover:text-white transition-all whitespace-nowrap group-hover:bg-sea-blue group-hover:text-white">
                  Ver Detalhes
                </button>
              </div>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Link
            to={`/apartamento-${apartments[2].id}`}
            className="group relative h-[420px] rounded-3xl overflow-hidden cursor-pointer"
            data-product-shop
          >
            <div className="absolute inset-0 w-full h-full">
              <img
                src={apartments[2].image}
                alt={apartments[2].name}
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            </div>
            
            <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full">
              <span className="text-navy-blue font-semibold text-sm">{apartments[2].type}</span>
            </div>

            <div className="absolute bottom-0 left-0 right-0 p-6 bg-white/95 backdrop-blur-md">
              <h3 className="text-2xl font-bold text-navy-blue mb-3">{apartments[2].name}</h3>
              <div className="flex items-center gap-4 text-gray-600 text-sm mb-4">
                <span className="flex items-center gap-1">
                  <i className="ri-user-line"></i> {apartments[2].capacity} pessoas
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-hotel-bed-line"></i> {apartments[2].beds} cama
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-plant-line"></i> {apartments[2].view}
                </span>
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <span className="text-nature-green font-bold text-2xl">€{apartments[2].price}</span>
                  <span className="text-gray-500 text-sm">/noite</span>
                </div>
                <button className="px-6 py-2.5 border-2 border-sea-blue text-sea-blue rounded-full font-semibold hover:bg-sea-blue hover:text-white transition-all whitespace-nowrap group-hover:bg-sea-blue group-hover:text-white">
                  Ver Detalhes
                </button>
              </div>
            </div>
          </Link>

          <Link
            to={`/apartamento-${apartments[3].id}`}
            className="group relative h-[420px] rounded-3xl overflow-hidden cursor-pointer"
            data-product-shop
          >
            <div className="absolute inset-0 w-full h-full">
              <img
                src={apartments[3].image}
                alt={apartments[3].name}
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            </div>
            
            <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full">
              <span className="text-navy-blue font-semibold text-sm">{apartments[3].type}</span>
            </div>

            <div className="absolute bottom-0 left-0 right-0 p-6 bg-white/95 backdrop-blur-md">
              <h3 className="text-2xl font-bold text-navy-blue mb-3">{apartments[3].name}</h3>
              <div className="flex items-center gap-4 text-gray-600 text-sm mb-4">
                <span className="flex items-center gap-1">
                  <i className="ri-user-line"></i> {apartments[3].capacity} pessoas
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-hotel-bed-line"></i> {apartments[3].beds} camas
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-water-flash-line"></i> {apartments[3].view}
                </span>
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <span className="text-nature-green font-bold text-2xl">€{apartments[3].price}</span>
                  <span className="text-gray-500 text-sm">/noite</span>
                </div>
                <button className="px-6 py-2.5 border-2 border-sea-blue text-sea-blue rounded-full font-semibold hover:bg-sea-blue hover:text-white transition-all whitespace-nowrap group-hover:bg-sea-blue group-hover:text-white">
                  Ver Detalhes
                </button>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ApartmentsSection;